<template>
  <v-tooltip top :disabled="!tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :id="id" class="v-btn" outlined elevation="2" :type="type" :block="block" :loading="loading" :color="mainColor" :disabled="disabled" :text="isText" @click="$event.preventDefault();$emit('click')"  v-bind="attrs" v-on="on" :style="styleString">
        {{text}}
        <v-icon>{{icon}}</v-icon>
      </v-btn>
    </template>
    <span>{{tooltip}}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'custom-button',
  props: {
    disabled: Boolean,
    text: String,
    icon: String,
    loading: Boolean,
    isText: Boolean,
    block: Boolean,
    type: String,
    tooltip: String,
    data_cy: String,
    color: String,
    styleString: String,
    id: String,
  },
  data() {
    return {
      mainColor: ''
    }
  },
  watch: {
    color() {
      if(!this.color) {
        this.mainColor = this.$vuetify.theme.themes.light.primary
      } else {
        this.mainColor = this.color
      }
    }
  },
  created: function () {
    if(!this.color) {
      this.mainColor = this.$vuetify.theme.themes.light.primary
    } else {
      this.mainColor = this.color
    }
  }
}
</script>

<style>
.v-btn {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
</style>
